<template>
	<div id="Main">
		<div class="content">
			<div class="htitle">
				<p class="h">修改账户密码</p>
				<p class="p">按步骤操作即可修改密码，不能是6位一样的数字</p>
			</div>
			<div class="inputbox">
				<div class="title">
					<van-icon class="icon" :name="require('../../assets/images/service/cipher.png')" />
					<span>原始密码</span>
				</div>
				<van-field class="input" type="password" maxlength="6" v-model="pass" placeholder="请输入原始密码" />
			</div>
			<div class="inputbox">
				<div class="title">
					<van-icon class="icon" :name="require('../../assets/images/service/cipher.png')" />
					<span>新密码</span>
				</div>
				<van-field class="input" type="password" maxlength="6" v-model="newpass" placeholder="请输入新密码" />
			</div>
			<div class="inputbox">
				<div class="title">
					<van-icon class="icon" :name="require('../../assets/images/service/cipher.png')" />
					<span>确认密码</span>
				</div>
				<van-field class="input" type="password" maxlength="6" v-model="newpasstwo" placeholder="请再次输入新密码" />
			</div>
			<van-button round type="info" :class="['submit',!disabled?'gary':'']" :disabled="!disabled" @click="submit">确定</van-button>
		</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				pass: '',
				newpass: '',
				newpasstwo: '',
				shareholderCode: '',
				openId: '',
				disabled: true,
				loginif:false//是否登录
			}
		},
		methods: {
			submit() {
				let t = this;
				if(!this.loginif){
					this.$router.push({
						path: "/register",
						query: {
							openId: this.openId
						}
					})
				}
				if (!this.disabled) {
					this.popup();
					// this.$toast({duration:4000,message:'您尚未实名认证，请先实名认证！'});
					return false;
				}
				if (this.pass.length == '') {
					this.$toast({duration:4000,message:'请输入原密码！'});
					return false;
				}
				if (this.newpass != this.newpasstwo && this.newpasstwo != '') {
					this.$toast({duration:4000,message:'两次新密码不一致，请重新输入！'});
					return false;
				}
				let ispass = false
				for (let i = 0, len = this.newpass.length; i < len; i++) {
					for (let j = 0, lenj = this.newpass.length; j < lenj; j++) {
						if (this.newpass[i] != this.newpass[j]) {
							ispass = true;
							break;
						}
					}
				}
				if (this.newpass.length != 6 || !ispass || isNaN(this.newpass)) {
					this.$toast({duration:4000,message:'密码为6位不重复数字，格式不正确，请重新输入！'});
					return false;
				}

				let params = '4900;' + this.shareholderCode + ';' + this.pass + ';' + this.newpass + ';;;;'
				axiosPost.getdata(params, this.code).then((res) => {
					if (res.data.filter && res.data.filter.msg) {
						this.$dialog.alert({
							title: '提示',
							message:res.data.filter.msg,
						}).then(() => {
							if (res.data.filter.code == 0) {
								share()
							}
						});
					}else{
						share()
					}
					function share(){
						let str = res.data.data
						if(res.data.code==200){
							let code = str.slice(0, str.indexOf(';'));
							if (code == 200) {
								t.$toast({duration:4000,message:'密码修改成功！'});
								t.$router.push({
									path: '/register'
								})
							} else if (code == 400) {
								t.$toast({duration:4000,message:'原密码错误，请重新输入！'});
							} else {
								t.$toast({duration:4000,message:str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！'});
							}
						}else{
							t.$toast({duration:4000,message:res.data.msg});
						}
					}
					
					
				}).catch((res) => {
					window.console.log(res)
				})
			},
			getShare() {
				axiosPost.getRealNameBindByOpenId({
					openId: this.openId
				}).then((res) => { /* 验证是否实名 */
					window.console.log(res.data)
					if(res.data.data&& res.data.data.shareholderCode){
						this.loginif=true;
						if (res.data.code == 200) {
							window.console.log('getShare200------',res.data)
							if (res.data.data && res.data.data.authenticationStatus && res.data.data.authenticationStatus == 1) {
								window.console.log('getShare------',res.data)
								this.shareholderCode=res.data.data.shareholderCode;
								
							} else {
								this.popup();
								this.disabled = false
							}
						} else {
							if(res.data.code == 400){
								this.$toast({duration:4000,message:'账号绑定失败请重新登录!'});
								this.disabled = false
								return false;
							}
							this.popup();
							this.disabled = false
						}
					}
					else{
						this.loginif=false;
						this.$router.push({
							path: "/register",
							query: {
								openId: this.openId
							}
						})
					}
				
				}).catch((res) => {
					window.console.log(res)
				})
			},
			popup() {
				if(this.loginif==true){
					this.$dialog.confirm({
						title: '提示',
						message: '您尚未实名认证，是否前往认证？'
					}).then(() => {
						this.$router.push({
							path: '/attestationlogin',
							query:{
								openId:this.openId,
							}
						})
					}).catch(() => {
						
					});
				}
	
			}
		},
		mounted() {
			this.openId = this.$route.query.openId
			this.getShare()
			// this.$dialog.alert({
			// 	message: '未实名无法修改密码'
			// })
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		min-height: 100vh;

		.htitle {
			padding: 2rem 1.3rem;
			text-align: left;

			.h {
				font-weight: bold;
				color: #333;
				font-size: 2rem;
			}

			.p {
				color: #999999;
				font-size: 1.6rem;
				margin-top: 0.5rem;
			}
		}

		.code {
			width: 70%;
			margin-left: auto;
			margin-right: auto;

			.codecontent {
				display: flex;

				.input {
					flex: 1;
				}
			}

			.inputbox {
				width: auto;
				flex: 1;
			}


			.codeimg {
				height: 4rem;
				padding-left: 1rem;
				line-height: 4rem;
				vertical-align: middle;

				.img {
					vertical-align: middle;
				}

				.icon {
					vertical-align: middle;
					margin-left: 1rem;
				}
			}
		}

		.title {
			text-align: left;
			line-height: 3rem;
			margin-left: -2.3rem;

			span {
				font-weight: bold;
				font-size: 1.8rem;
				color: #333;
			}

			.icon {
				vertical-align: -0.25rem;
				margin-right: 0.8rem;
			}
		}

		.inputbox {
			margin-bottom: 2rem;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;

			.input {
				flex: 1;
				padding: 0;
				height: 4rem;
				line-height: 4rem;

				&:not(:last-child):after {
					display: none;
				}
			}
		}

		.submit {
			width: 70%;
			background-color: #fa6b6b;
			border: 0;
			margin-top: 3rem;
			font-size: 1.6rem;
			&.gary{
				background-color: #aaa;
			}
		}
	}
</style>
